// extracted by mini-css-extract-plugin
export var defaultWrapper = "_fu-3";
export var downloadButton = "_fu-4";
export var fileContainer = "_fu-9 _fu-7";
export var fileContainerBase = "_fu-7";
export var fileContainerFixedHeight = "_fu-8 _fu-7";
export var fileInfo = "_fu-5";
export var fileInfoWidthRestricted = "_fu-6";
export var fileType = "_fu-1";
export var fileTypeName = "_fu-2";
export var image = "_fu-0";
export var link = "_fu-b";
export var overflowEllipsis = "_fu-a";